import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { EmployeePositionId } from '../../../classes/models/employee/Employee';
import { MaximumWorkingHours } from '../../../classes/models/employee/MaximumWorkingHours';
import {
  AddEmployeeMaximumWorkHoursRequest,
  EditEmployeeMaximumWorkHoursRequest
} from '../../../interfaces/request/EmployeeRequests';
import moment from 'moment';

/**
 * This service communicates with backend to handle employee maximum working hours data management.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeMaximumWorkingHoursService {
  private http = inject(HttpClient);

  url = environment.apiUrl + '/employees';

  /**
   * Adds a new maximum working hours limit to the employee.
   * @param id identifiers of employee and position.
   * @param maximumWorking a new maximum working hours limit.
   */
  addMaximumWorkingHours(id: EmployeePositionId, maximumWorking: MaximumWorkingHours) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/maximum-work-hours`;
    const requestBody: AddEmployeeMaximumWorkHoursRequest = {
      date: maximumWorking.startDate,
      duration: moment.duration(maximumWorking.hours, 'hours').toISOString()
    };
    return this.http.post(url, requestBody);
  }

  /**
   * Edits maximum working hours limit for the employee.
   * @param id identifiers of employee and position.
   * @param maximumWorking a new maximum working hours limit.
   */
  editMaximumWorkingHours(id: EmployeePositionId, maximumWorking: MaximumWorkingHours) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/maximum-work-hours/${maximumWorking.startDate}`;
    const requestBody: EditEmployeeMaximumWorkHoursRequest = {
      duration: moment.duration(maximumWorking.hours, 'hours').toISOString()
    };
    return this.http.put(url, requestBody);
  }

  /**
   * Deletes a maximum working hours limit from the employee.
   * @param id identifiers of employee and position.
   * @param date start date of maximum work hours.
   */
  deleteMaximumWorkingHours(id: EmployeePositionId, date: string) {
    const url = `${this.url}/${id.parseEmployeeId()}/positions/${id.parsePositionId()}/maximum-work-hours/${date}`;
    return this.http.delete(url);
  }
}
